import React from "react";
import * as LucideIcons from "lucide-react";
import PolySphere from "@/components/PolySphere";

/**
 * Low-poly creature visualization. The lucide icon represents the animal
 * silhouette and the surrounding rotating geodesic mesh provides the
 * "low-poly line-art spinning" treatment.
 */
export default function PolyAnimal({ icon = "Asterisk", size = 320, spinDuration = 30 }) {
  const Icon = LucideIcons[icon] || LucideIcons.Asterisk;
  const iconSize = Math.round(size * 0.42);
  return (
    <div
      className="relative grid place-items-center"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {/* Rotating wireframe sphere — spins; the creature stays still in center */}
      <div className="absolute inset-0" style={{ animation: `spinY ${spinDuration}s linear infinite` }}>
        <PolySphere size={size} />
      </div>
      {/* Counter-rotating subtle inner ring for layered motion */}
      <div className="absolute inset-[18%]" style={{ animation: `spinY ${spinDuration * 0.6}s linear infinite reverse` }}>
        <PolySphere size={Math.round(size * 0.64)} color="rgba(255,255,255,0.2)" dotColor="rgba(255,255,255,0.4)" />
      </div>
      {/* Static low-poly animal silhouette */}
      <div className="relative">
        <Icon
          size={iconSize}
          strokeWidth={1.25}
          color="#ffffff"
          style={{ filter: "drop-shadow(0 0 18px rgba(255,255,255,0.35))" }}
        />
      </div>
    </div>
  );
}
